<script>
import Card from "../../components/Card.vue";
import FirstSection from "./components/FirstSection.vue";
import SecondSection from "./components/SecondSection.vue";
import AboutTheCompany from "./components/AboutTheCompany.vue";
import VMV from './components/VMV.vue';
import Milestones from './components/Milestones.vue';
import Products from './components/Products.vue';
import Networks from './components/Networks.vue';
import Memberships from './components/Memberships.vue';
import Awards from './components/Awards.vue';

export default {
  components: {
    Card,
    FirstSection,
    SecondSection,
    AboutTheCompany,
    VMV,
    Milestones,
    Products,
    Networks,
    Memberships,
    Awards,
  },

  data() {
    return {
      loading: true,
      years: [],
    }
  },
  computed: {
    selectedCompanyId() {
      return sessionStorage.getItem('audited_company_id');
    },
  },

  methods: {
    async setupYears() {
      let currYear = new Date().getFullYear();
      while (currYear > 1900) {
        this.years.push(currYear);
        currYear--;
      }
    }
  },

  mounted() {
    this.setupYears()
      .then(_ => {
        this.loading = false;
      })
  },
}

</script>


<template>
  <div id="companyProfile">
    <div v-if="loading" class="text-center">
      <b-spinner variant="success"></b-spinner>
    </div>
    <div v-else>
      <br>

      <Card>
        <FirstSection :allDisabled="true" :selectedCompanyId="selectedCompanyId" :userInfo="$user" />
      </Card>

      <Card>
        <SecondSection :allDisabled="true" :selectedCompanyId="selectedCompanyId" />
      </Card>

      <h3 class="special-h3">
        {{ $t('companyProfile.modal3.header') }}
      </h3>
      <Card>
        <AboutTheCompany :allDisabled="true" :selectedCompanyId="selectedCompanyId" />
      </Card>

      <div style="
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;
        align-content: center;
        margin-bottom: 4em;
      ">
        <div style="flex: 1; margin-right: 1.5em; margin-top: .5em;">
          <h3 class="special-h3">
            {{ $t('companyProfile.modal5.header1') }}
          </h3>
          <Card style="height: 100%;">
            <VMV :allDisabled="true" :selectedCompanyId="selectedCompanyId" :type="'vision'" />
          </Card>
        </div>

        <div style="flex: 1; margin-top: .5em;">
          <h3 class="special-h3">
            {{ $t('companyProfile.modal5.header2') }}
          </h3>
          <Card style="height: 100%;">
            <VMV :allDisabled="true" :selectedCompanyId="selectedCompanyId" :type="'mission'" />
          </Card>
        </div>

        <div style="flex: 1; margin-left: 1.5em; margin-top: .5em;">
          <h3 class="special-h3">
            {{ $t('companyProfile.modal5.header3') }}
          </h3>
          <Card style="height: 100%;">
            <VMV :allDisabled="true" :selectedCompanyId="selectedCompanyId" :type="'values'" />
          </Card>
        </div>
      </div>

      <br><br>

      <h3 class="special-h3">
        {{ $t('companyProfile.modal6.header') }}
      </h3>
      <Card>
        <Milestones :allDisabled="true" :selectedCompanyId="selectedCompanyId" :userId="$user.user_id" :years="years" />
      </Card>

      <h3 class="special-h3">
        {{ $t('companyProfile.modal7.header') }}
      </h3>
      <Card>
        <Products :allDisabled="true" :selectedCompanyId="selectedCompanyId" :userId="$user.user_id" :years="years" />
      </Card>

      <h3 class="special-h3">
        {{ $t('companyProfile.modal8.header') }}
      </h3>
      <Card>
        <Networks :allDisabled="true" :selectedCompanyId="selectedCompanyId" :userId="$user.user_id" :years="years" />
      </Card>

      <h3 class="special-h3">
        {{ $t('companyProfile.modal9.header') }}
      </h3>
      <Card>
        <Memberships :allDisabled="true" :selectedCompanyId="selectedCompanyId" :userId="$user.user_id" :years="years" />
      </Card>

      <h3 class="special-h3">
        {{ $t('companyProfile.modal10.header') }}
      </h3>
      <Card>
        <Awards :allDisabled="true" :selectedCompanyId="selectedCompanyId" :userId="$user.user_id" :years="years" />
      </Card>

    </div>
  </div>
</template>

<style lang="scss">
.special-h3 {
  color: black !important;
  font-style: italic !important;
  font-weight: bolder !important;
  text-align: left !important;
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif !important;
}
</style>